import { useContext, useEffect, useRef, useState } from 'react';
import { ArrowLeft, Users } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import TableSessionContext from '../../Context/TableSession/TableSessionContext';

export default function ReturnToTable() {
  const { recover } = useContext(TableSessionContext);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const attempted = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;
    const token = searchParams.get('token');
    if (!token) {
      setError('This return link is incomplete.');
      return;
    }

    recover(token)
      .then((result) => {
        localStorage.setItem('merchant_id', result.restaurantId);
        localStorage.setItem('table_number', result.tableRef);
        navigate('/order', {
          replace: true,
          state: {
            merchantId: result.restaurantId,
            table_number: result.tableRef,
            table_session_id: result.session?.id,
          },
        });
      })
      .catch((requestError) => {
        setError(requestError?.response?.data?.error || requestError?.message || 'This group order could not be restored.');
      });
  }, [navigate, recover, searchParams]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#f5f3ee] px-5 text-neutral-950">
      <div className="w-full max-w-sm text-center">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-white shadow-sm">
          <Users className="h-5 w-5" />
        </span>
        {error ? (
          <>
            <h1 className="mt-5 text-2xl font-semibold">This group order is no longer available</h1>
            <p className="mt-3 text-sm leading-6 text-neutral-600">{error}</p>
            <button type="button" onClick={() => navigate('/', { replace: true })} className="mt-7 inline-flex h-11 items-center gap-2 rounded-xl bg-[#0D3031] px-5 text-sm font-semibold text-white">
              <ArrowLeft className="h-4 w-4" /> Scan another table
            </button>
          </>
        ) : (
          <>
            <div className="mx-auto mt-6 h-8 w-8 animate-spin rounded-full border-2 border-neutral-300 border-t-[#0D3031]" />
            <h1 className="mt-5 text-xl font-semibold">Returning to your table</h1>
            <p className="mt-2 text-sm text-neutral-600">Restoring the open group order securely.</p>
          </>
        )}
      </div>
    </main>
  );
}
